import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/apiClient";
import { toast } from "sonner";

export default function Onboarding() {
  const navigate = useNavigate();
  const { user, switchRole, setUser } = useAuth();
  const [role, setRole] = useState(user?.role || "learner");
  const [bio, setBio] = useState("");

  const finish = async () => {
    await switchRole(role);
    if (bio) {
      const res = await api.patch("/users/me", { bio });
      setUser(res.data);
    }
    toast.success("You're all set!");
    navigate(role === "instructor" ? "/studio" : "/feed");
  };

  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center px-4 relative z-10">
      <div className="w-full max-w-lg bg-[#1E1E1E] border border-[#2A2A2A] rounded-2xl p-8">
        <h1 className="font-display font-bold text-3xl uppercase tracking-tight text-white mb-2">Choose your path</h1>
        <p className="text-sm text-[#A0A0A0] mb-6">You can switch anytime from the header.</p>
        <div className="grid grid-cols-2 gap-3 mb-5">
          {[{ id: "learner", label: "Train" }, { id: "instructor", label: "Coach" }].map((r) => (
            <button
              key={r.id}
              data-testid={`onboarding-role-${r.id}`}
              onClick={() => setRole(r.id)}
              className={`py-6 rounded-xl font-display font-bold uppercase tracking-wide border transition-colors ${
                role === r.id ? "border-[#FF6B6B] bg-[#FF6B6B]/10 text-[#FF6B6B]" : "border-[#2A2A2A] text-[#A0A0A0]"
              }`}
            >
              {r.label}
            </button>
          ))}
        </div>
        <textarea
          data-testid="onboarding-bio-input"
          value={bio}
          onChange={(e) => setBio(e.target.value)}
          placeholder="Tell us about yourself (optional)"
          rows={3}
          className="w-full bg-[#121212] border border-[#2A2A2A] rounded-xl px-4 py-3 text-sm text-white placeholder-[#A0A0A0] focus:outline-none focus:ring-1 focus:ring-[#FF6B6B] mb-5"
        />
        <button data-testid="onboarding-finish-btn" onClick={finish} className="w-full py-3 rounded-xl bg-[#FF6B6B] text-black font-bold uppercase tracking-wide text-sm hover:brightness-110 transition-all">
          Enter CommunityPump
        </button>
      </div>
    </div>
  );
}
